<template>
  <div>
    <div class="py-2">
      <span><strong>Total per day</strong></span>
    </div>
    <VueApexCharts
      :options="chartDataOptions"
      :series="props.seriesData"
      height="350"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { defineProps, computed, toRaw } from "vue";
import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
    default: () => [],
  },
  // categories: {
  //   type: Array,
  //   required: false,
  // },
});

// const chartData = computed(() => {
//   // if(props.seriesData?.data.length ?? 0 === 0) return []
//   // console.log(props.seriesData[2022])

//   const values = [{ name: "eh", data: [] }];
//   props.seriesData?.[2022].data.forEach((element) => {
//     values[0].data.push(element.values);
//   }) ?? [];

//   return values;
// });

const avgData = computed(() =>  {
  const numbers = toRaw(props.seriesData[0].data).filter(number => number.y).map(number => number.y)
  const avg = numbers.reduce((acc, cur) => acc + cur, 0) / props.seriesData[0].data.length

  return avg
})

const chartDataOptions = computed(() => {
  const options = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: true,
      },
      data: "dates",
    },
    xaxis: {
      type: 'datetime',
      labels: {
        show: true,
        hideOverlappingLabels: true,
      }
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    colors: ["#0c1e36"],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    // labels: ['Dec 01', 'Dec 02', 'Dec 03', 'Dec 04', 'Dec 05', 'Dec 06', 'Dec 07', 'Dec 08', 'Dec 09 ', 'Dec 10', 'Dec 11'],
    markers: {
      size: 0,
    },
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return val + " kWh";
        },
      },
    },
    annotations: {
      yaxis: [
        {
          y: avgData.value,
          y2: avgData.value - 10,
          opacity: 1,
          fillColor: "#2B978D",
          borderColor: '#2B978D',
          label: {
            textAnchor: 'start',
            position: 'left',
            borderColor: '#2B978D',
            borderWidth: 5,
            style: {
              color: '#fff',
              width: '2px',
              background: '#2B978D'
            },
            text: `Average Consumption Per Day (${avgData.value.toFixed(2)} kWh)`,
          }
        }
      ]
    }
    // xaxis: {
    //   categories: props.seriesData?.[2022].data.map((element) => {
    //     return element.labels;
    //   }) ?? [],
    // },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    // }
  };

  return options;
});
</script>
